// extracted by mini-css-extract-plugin
export default {"container":"countdown_container__L7G90","inner":"countdown_inner__1np0C","label":"countdown_label__24IPQ","countdown":"countdown_countdown__2Vzdz","button":"countdown_button__1OmCR"};